import ShapeElement from './ShapeElement';
import ShapeElementPresets from './ShapeElementPresets';
import ShapeElementMetaData from './ShapeElementMetaData';
import ShapeElementProps from './ShapeElementProps';

export default {
  metaData: ShapeElementMetaData,
  elementClass: ShapeElement,
  elementProps: ShapeElementProps,
  presets: ShapeElementPresets
};
